import { FormattableDateValue } from '../types';

/**
 *
 * @param value
 */

const isDateValid = (value: FormattableDateValue): boolean => {
  if (!value) {
    return false;
  }

  return !Number.isNaN(new Date(value).getTime());
};

export default isDateValid;
